module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.ttf?56c8d80832e37783f12c05db7c8849e2";